import { render, staticRenderFns } from "./cardHTTPAttachments.vue?vue&type=template&id=2203e804&scoped=true&"
import script from "./cardHTTPAttachments.vue?vue&type=script&lang=js&"
export * from "./cardHTTPAttachments.vue?vue&type=script&lang=js&"
import style0 from "./cardHTTPAttachments.vue?vue&type=style&index=0&id=2203e804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203e804",
  null
  
)

component.options.__file = "cardHTTPAttachments.vue"
export default component.exports